import React from "react";

import { useFormikContext } from "formik";
import { useSelector } from "react-redux";

import EIDsCollapse from "components/DetailedSaleLotModal/EIDsCollapse";
import {
  ScanningDetails,
  TagsUsedOrScanLabelCounts,
} from "components/DetailedSaleLotModal/ScanningCollapse";
import { ForLivestockSale } from "containers/ForSaleType";
import { withNamespace } from "components/Form/FormikControls/lib";
import { getConsignmentById } from "selectors";
import { useToggle } from "hooks";

import { MobileTransactionalCreateSaleFormValues } from "../lib/types";

interface NlisTabProps {
  saleLotId: string;
  saleLotNamespace: string;
}

export const NlisTab = ({ saleLotId, saleLotNamespace }: NlisTabProps) => {
  const { values } =
    useFormikContext<MobileTransactionalCreateSaleFormValues>();
  const [isEIDsOpen, toggleEIDs] = useToggle(false);

  const consignment = useSelector(
    getConsignmentById(values.saleLot.consignment_id),
  );
  const vendorPropertyId = consignment?.vendor_property_id;

  const quantity = values.saleLot.quantity ?? 0;
  const quantityProgeny = values.saleLot.quantity_progeny ?? 0;

  return (
    <ForLivestockSale>
      <>
        <ScanningDetails
          saleLotId={saleLotId}
          quantity={quantity}
          quantityProgeny={quantityProgeny}
          readOnly={false}
        />
        <TagsUsedOrScanLabelCounts
          saleLotId={saleLotId}
          quantityTagsUsedFieldName={withNamespace(
            saleLotNamespace,
            "quantityTagsUsed",
          )}
          readOnly={false}
        />
        <EIDsCollapse
          isOpen={isEIDsOpen}
          onToggle={toggleEIDs}
          saleLotId={saleLotId}
          vendorPropertyId={vendorPropertyId}
          readOnly={false}
        />
      </>
    </ForLivestockSale>
  );
};
